import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import Button from '@/components/UI/Button';
import { HookForm } from '@/components/UI/HookForm/Form';
import { HookInput } from '@/components/UI/HookForm/Form/Input';
import { HookFormProvider } from '@/components/UI/HookForm/Provider';
import { passwordRegEx } from '../../Auth/PartnerAuth/SignUp/ClientOnboardForm/validationSchema';

interface PasswordInterface {
  currentPassword: string;
  newPassword: string;
  passwordConfirmation: string;
}

export default function Password() {
  const validationSchema = Yup.object({
    currentPassword: Yup.string().required('Current Password is required.'),
    newPassword: Yup.string()
      .required('New Password is required.')
      .matches(
        passwordRegEx,
        'Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character !@#$%^&*'
      ),
    passwordConfirmation: Yup.string()
      .required('Password confirmation is required')
      .oneOf([Yup.ref('newPassword')], 'Password must match'),
  });

  const handleSubmit = (data: any) => {
    console.log(data);
  };

  return (
    <HookFormProvider resolver={yupResolver(validationSchema)} mode='all'>
      <HookForm className='pb-10' onSubmit={handleSubmit}>
        <h3>Password</h3>
        <HookInput label='Current password' type='password' name='currentPassword' />
        <HookInput label='New password' type='password' name='newPassword' />
        <HookInput label='Confirm new password' type='password' name='passwordConfirmation' />
        <div className='mt-8'>
          <Button label='Save' type='submit' btnStyle='btn-primary' />
        </div>
      </HookForm>
    </HookFormProvider>
  );
}
